/* ═══════════════════════════════════════════════════════════════════════════
   heroStrings.js — hero-copy for alle sju språk
   Chamcore Technologies

   Slå inn i LangContext.jsx:

     import { HERO } from "./heroStrings.js";
     const TR = {
       no: { ...restenAvNorsk,   hero: HERO.no },
       en: { ...restenAvEngelsk, hero: HERO.en },
       sv: { ...restenAvSvensk,  hero: HERO.sv },
       da: { ...restenAvDansk,   hero: HERO.da },
       nl: { ...restenAvNederlandsk, hero: HERO.nl },
       de: { ...restenAvTysk,    hero: HERO.de },
       es: { ...restenAvSpansk,  hero: HERO.es },
     };

   Struktur per språk:
     badge, h1a, h1b (aksentfarget linje), h1c, p
     checks[]      De TO FØRSTE vises på mobil (under 560px). Rekkefølgen er
                   derfor ikke tilfeldig: nettside-inkludert og booking/levering
                   står først fordi de bærer hovedbudskapet.
     cta1, cta2, note
     partnerPre / partnerPost   Teksten rundt vipps-logoen, som settes inline.
     partnerSub, payLabel, vtLabel
     verticals[]   Bransjevelgeren. Bytter hele mockupen.
   ═══════════════════════════════════════════════════════════════════════════ */

export const PAY_METHODS = ["MobilePay","Swish","Apple Pay","Google Pay","Klarna","Visa","Mastercard"];

export const HERO = {

/* ── NORSK ──────────────────────────────────────────────────────────────── */
no:{
  badge:"Operative bransjeløsninger",
  h1a:"Ferdig driftssystem", h1b:"for din bransje.", h1c:"Nettsiden er inkludert.",
  p:"Vi leverer ikke bare telefoni, video og betaling. Vi leverer hele driften, som en systembasert nettside der booking, levering, betaling og fakturering er integrerte moduler. Ferdig konfigurert for din bransje fra dag én.",
  checks:[
    "Systembasert nettside alltid inkludert i alle planer, aldri et tillegg",
    "Booking og leveringsverktøy i alle løsninger, tilpasset bransjen",
    "Telefoni, video, betaling og fakturering som moduler i samme system",
    "Din merkevare på ditt eget domene, eller driftet av oss",
  ],
  cta1:"Book en demo", cta2:"Se priser",
  note:"Engangs oppsett, deretter en fast månedslisens. Vi tar aldri en andel av inntekten din.",
  partnerPre:"Autorisert ", partnerPost:" MobilePay-partner",
  partnerSub:"Vipps- og MobilePay-betaling er innebygd i alle løsninger",
  payLabel:"Betaling", vtLabel:"Ferdige løsninger for",
  verticals:[
    {key:"helse", label:"Helse", icon:"ti-stethoscope",
     card:{url:"klinikk.no", brand:"DIN KLINIKK", nav:["Behandlinger","Behandlere","Priser"],
       tabs:["Nettside","Timebok","Video","Betaling","Påminnelser"], title:"Dagens timer",
       k1:"Autorisert på forhånd", k2:"Purring på faktura",
       foot:"Timebok, videokonsultasjon, betaling og påminnelser. Alle moduler i klinikkens egen nettside."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Konsultasjon · 09:15",badge:"Autorisert"},
           {init:"TN",name:"Thomas Nilsen",meta:"Video · 10:00",badge:"Pågår"},
           {init:"SB",name:"Sara Berg",meta:"Oppfølging · 10:45",badge:"Fakturert"}]},
    {key:"restaurant", label:"Restaurant", icon:"ti-tools-kitchen-2",
     card:{url:"restauranten.no", brand:"DIN RESTAURANT", nav:["Meny","Bestill","Bord"],
       tabs:["Nettside","Meny","Bestilling","Levering","Betaling"], title:"Aktive ordrer",
       k1:"Betalt før levering", k2:"Manuell ordreføring",
       foot:"Meny, bestilling, levering og betaling. Alle moduler i restaurantens egen nettside."},
     rows:[{init:"#4",name:"Ordre 1204",meta:"Levering · 12:04",badge:"Betalt"},
           {init:"#5",name:"Ordre 1205",meta:"Take-away · 12:11",badge:"Tilberedes"},
           {init:"B7",name:"Bord 7",meta:"Reservasjon · 19:30",badge:"Bekreftet"}]},
    {key:"skjonnhet", label:"Skjønnhetspleie", icon:"ti-sparkles",
     card:{url:"salongen.no", brand:"DIN SALONG", nav:["Behandlinger","Ansatte","Book time"],
       tabs:["Nettside","Booking","Ansatte","Betaling","Påminnelser"], title:"Dagens bookinger",
       k1:"Forhåndsbetalt", k2:"Manuell booking",
       foot:"Booking, ansattkalender, betaling og påminnelser. Alle moduler i salongens egen nettside."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Klipp & farge · 11:00",badge:"Forhåndsbetalt"},
           {init:"TN",name:"Thomas Nilsen",meta:"Behandling · 13:30",badge:"Bekreftet"},
           {init:"SB",name:"Sara Berg",meta:"Ny kunde · 15:00",badge:"Betalt"}]},
    {key:"radgivning", label:"Rådgivning", icon:"ti-headset",
     card:{url:"eksperter.no", brand:"DIN PLATTFORM", nav:["Eksperter","Fagområder","Priser"],
       tabs:["Nettside","Ekspertprofiler","Telefoni","Video","Betaling"], title:"Live samtalekø",
       k1:"Autorisert på forhånd", k2:"Purring på faktura",
       foot:"Telefoni, video og per-minutt-betaling. Alle moduler i din egen nettside."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Rådgivning · 12:04",badge:"Autorisert"},
           {init:"TN",name:"Thomas Nilsen",meta:"Juridisk · 08:47",badge:"Pågår"},
           {init:"SB",name:"Sara Berg",meta:"Support · Video",badge:"Fakturert"}]},
  ],
},

/* ── ENGELSK ────────────────────────────────────────────────────────────── */
en:{
  badge:"Operational industry solutions",
  h1a:"A ready-made system", h1b:"for your industry.", h1c:"The website is included.",
  p:"We don't just do telephony, video and payments. We deliver the whole operation, as a system-based website where booking, delivery, payments and invoicing are integrated modules. Configured for your industry from day one.",
  checks:[
    "A system-based website is always included in every plan, never an add-on",
    "Booking and delivery tools in every solution, tailored to the industry",
    "Telephony, video, payments and invoicing as modules in the same system",
    "Your brand on your own domain, or hosted and run by us",
  ],
  cta1:"Book a demo", cta2:"See pricing",
  note:"One-time setup, then a flat monthly licence. We never take a share of your revenue.",
  partnerPre:"Authorised ", partnerPost:" MobilePay partner",
  partnerSub:"Vipps and MobilePay payment is built into every solution",
  payLabel:"Payments", vtLabel:"Ready-made solutions for",
  verticals:[
    {key:"health", label:"Healthcare", icon:"ti-stethoscope",
     card:{url:"yourclinic.com", brand:"YOUR CLINIC", nav:["Treatments","Practitioners","Pricing"],
       tabs:["Website","Appointments","Video","Payments","Reminders"], title:"Today's appointments",
       k1:"Authorised up front", k2:"Chasing invoices",
       foot:"Appointments, video consultation, payments and reminders. All modules in the clinic's own website."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Consultation · 09:15",badge:"Authorised"},
           {init:"TN",name:"Thomas Nilsen",meta:"Video · 10:00",badge:"In progress"},
           {init:"SB",name:"Sara Berg",meta:"Follow-up · 10:45",badge:"Invoiced"}]},
    {key:"restaurant", label:"Restaurants", icon:"ti-tools-kitchen-2",
     card:{url:"yourrestaurant.com", brand:"YOUR RESTAURANT", nav:["Menu","Order","Tables"],
       tabs:["Website","Menu","Ordering","Delivery","Payments"], title:"Active orders",
       k1:"Paid before delivery", k2:"Manual order entry",
       foot:"Menu, ordering, delivery and payments. All modules in the restaurant's own website."},
     rows:[{init:"#4",name:"Order 1204",meta:"Delivery · 12:04",badge:"Paid"},
           {init:"#5",name:"Order 1205",meta:"Take-away · 12:11",badge:"Preparing"},
           {init:"T7",name:"Table 7",meta:"Reservation · 19:30",badge:"Confirmed"}]},
    {key:"beauty", label:"Beauty & salon", icon:"ti-sparkles",
     card:{url:"yoursalon.com", brand:"YOUR SALON", nav:["Treatments","Staff","Book now"],
       tabs:["Website","Booking","Staff","Payments","Reminders"], title:"Today's bookings",
       k1:"Prepaid", k2:"Manual booking",
       foot:"Booking, staff calendar, payments and reminders. All modules in the salon's own website."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Cut & colour · 11:00",badge:"Prepaid"},
           {init:"TN",name:"Thomas Nilsen",meta:"Treatment · 13:30",badge:"Confirmed"},
           {init:"SB",name:"Sara Berg",meta:"New client · 15:00",badge:"Paid"}]},
    {key:"consulting", label:"Consultation", icon:"ti-headset",
     card:{url:"yourexperts.com", brand:"YOUR PLATFORM", nav:["Experts","Fields","Pricing"],
       tabs:["Website","Expert profiles","Telephony","Video","Payments"], title:"Live call queue",
       k1:"Authorised up front", k2:"Chasing invoices",
       foot:"Telephony, video and per-minute billing. All modules in your own website."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Advisory · 12:04",badge:"Authorised"},
           {init:"TN",name:"Thomas Nilsen",meta:"Legal · 08:47",badge:"In progress"},
           {init:"SB",name:"Sara Berg",meta:"Support · Video",badge:"Invoiced"}]},
  ],
},

/* ── SVENSK ─────────────────────────────────────────────────────────────── */
sv:{
  badge:"Operativa branschlösningar",
  h1a:"Ett färdigt driftsystem", h1b:"för din bransch.", h1c:"Webbplatsen ingår.",
  p:"Vi levererar inte bara telefoni, video och betalning. Vi levererar hela driften, som en systembaserad webbplats där bokning, leverans, betalning och fakturering är integrerade moduler. Färdigt konfigurerat för din bransch från dag ett.",
  checks:[
    "Systembaserad webbplats ingår alltid i alla planer, aldrig ett tillägg",
    "Bokning och leveransverktyg i alla lösningar, anpassade till branschen",
    "Telefoni, video, betalning och fakturering som moduler i samma system",
    "Ditt varumärke på din egen domän, eller driftat av oss",
  ],
  cta1:"Boka en demo", cta2:"Se priser",
  note:"Engångskostnad för uppsättning, sedan en fast månadslicens. Vi tar aldrig en andel av din omsättning.",
  partnerPre:"Auktoriserad ", partnerPost:" MobilePay-partner",
  partnerSub:"Betalning med Vipps och MobilePay är inbyggd i alla lösningar",
  payLabel:"Betalning", vtLabel:"Färdiga lösningar för",
  verticals:[
    {key:"halsa", label:"Hälsa", icon:"ti-stethoscope",
     card:{url:"kliniken.se", brand:"DIN KLINIK", nav:["Behandlingar","Behandlare","Priser"],
       tabs:["Webbplats","Tidbok","Video","Betalning","Påminnelser"], title:"Dagens tider",
       k1:"Auktoriserat i förväg", k2:"Jaga fakturor",
       foot:"Tidbok, videokonsultation, betalning och påminnelser. Alla moduler i klinikens egen webbplats."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Konsultation · 09:15",badge:"Auktoriserad"},
           {init:"TN",name:"Thomas Nilsen",meta:"Video · 10:00",badge:"Pågår"},
           {init:"SB",name:"Sara Berg",meta:"Uppföljning · 10:45",badge:"Fakturerad"}]},
    {key:"restaurang", label:"Restaurang", icon:"ti-tools-kitchen-2",
     card:{url:"restaurangen.se", brand:"DIN RESTAURANG", nav:["Meny","Beställ","Bord"],
       tabs:["Webbplats","Meny","Beställning","Leverans","Betalning"], title:"Aktiva ordrar",
       k1:"Betalt före leverans", k2:"Manuell orderhantering",
       foot:"Meny, beställning, leverans och betalning. Alla moduler i restaurangens egen webbplats."},
     rows:[{init:"#4",name:"Order 1204",meta:"Leverans · 12:04",badge:"Betald"},
           {init:"#5",name:"Order 1205",meta:"Take-away · 12:11",badge:"Tillagas"},
           {init:"B7",name:"Bord 7",meta:"Bokning · 19:30",badge:"Bekräftad"}]},
    {key:"skonhet", label:"Skönhetsvård", icon:"ti-sparkles",
     card:{url:"salongen.se", brand:"DIN SALONG", nav:["Behandlingar","Personal","Boka tid"],
       tabs:["Webbplats","Bokning","Personal","Betalning","Påminnelser"], title:"Dagens bokningar",
       k1:"Förbetalt", k2:"Manuell bokning",
       foot:"Bokning, personalkalender, betalning och påminnelser. Alla moduler i salongens egen webbplats."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Klippning & färg · 11:00",badge:"Förbetald"},
           {init:"TN",name:"Thomas Nilsen",meta:"Behandling · 13:30",badge:"Bekräftad"},
           {init:"SB",name:"Sara Berg",meta:"Ny kund · 15:00",badge:"Betald"}]},
    {key:"radgivning", label:"Rådgivning", icon:"ti-headset",
     card:{url:"experterna.se", brand:"DIN PLATTFORM", nav:["Experter","Områden","Priser"],
       tabs:["Webbplats","Expertprofiler","Telefoni","Video","Betalning"], title:"Live samtalskö",
       k1:"Auktoriserat i förväg", k2:"Jaga fakturor",
       foot:"Telefoni, video och betalning per minut. Alla moduler i din egen webbplats."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Rådgivning · 12:04",badge:"Auktoriserad"},
           {init:"TN",name:"Thomas Nilsen",meta:"Juridik · 08:47",badge:"Pågår"},
           {init:"SB",name:"Sara Berg",meta:"Support · Video",badge:"Fakturerad"}]},
  ],
},

/* ── DANSK ──────────────────────────────────────────────────────────────── */
da:{
  badge:"Operative brancheløsninger",
  h1a:"Et færdigt driftssystem", h1b:"til din branche.", h1c:"Hjemmesiden er inkluderet.",
  p:"Vi leverer ikke kun telefoni, video og betaling. Vi leverer hele driften, som en systembaseret hjemmeside hvor booking, levering, betaling og fakturering er integrerede moduler. Færdigkonfigureret til din branche fra dag ét.",
  checks:[
    "Systembaseret hjemmeside altid inkluderet i alle planer, aldrig et tillæg",
    "Booking og leveringsværktøjer i alle løsninger, tilpasset branchen",
    "Telefoni, video, betaling og fakturering som moduler i samme system",
    "Dit brand på dit eget domæne, eller driftet af os",
  ],
  cta1:"Book en demo", cta2:"Se priser",
  note:"Engangsbeløb for opsætning, derefter en fast månedlig licens. Vi tager aldrig en andel af din omsætning.",
  partnerPre:"Autoriseret ", partnerPost:" MobilePay-partner",
  partnerSub:"Betaling med MobilePay og Vipps er indbygget i alle løsninger",
  payLabel:"Betaling", vtLabel:"Færdige løsninger til",
  verticals:[
    {key:"sundhed", label:"Sundhed", icon:"ti-stethoscope",
     card:{url:"klinikken.dk", brand:"DIN KLINIK", nav:["Behandlinger","Behandlere","Priser"],
       tabs:["Hjemmeside","Tidsbog","Video","Betaling","Påmindelser"], title:"Dagens tider",
       k1:"Godkendt på forhånd", k2:"Rykke for fakturaer",
       foot:"Tidsbog, videokonsultation, betaling og påmindelser. Alle moduler i klinikkens egen hjemmeside."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Konsultation · 09:15",badge:"Godkendt"},
           {init:"TN",name:"Thomas Nilsen",meta:"Video · 10:00",badge:"I gang"},
           {init:"SB",name:"Sara Berg",meta:"Opfølgning · 10:45",badge:"Faktureret"}]},
    {key:"restaurant", label:"Restaurant", icon:"ti-tools-kitchen-2",
     card:{url:"restauranten.dk", brand:"DIN RESTAURANT", nav:["Menu","Bestil","Borde"],
       tabs:["Hjemmeside","Menu","Bestilling","Levering","Betaling"], title:"Aktive ordrer",
       k1:"Betalt før levering", k2:"Manuel ordreindtastning",
       foot:"Menu, bestilling, levering og betaling. Alle moduler i restaurantens egen hjemmeside."},
     rows:[{init:"#4",name:"Ordre 1204",meta:"Levering · 12:04",badge:"Betalt"},
           {init:"#5",name:"Ordre 1205",meta:"Take-away · 12:11",badge:"Tilberedes"},
           {init:"B7",name:"Bord 7",meta:"Reservation · 19:30",badge:"Bekræftet"}]},
    {key:"skonhed", label:"Skønhedspleje", icon:"ti-sparkles",
     card:{url:"salonen.dk", brand:"DIN SALON", nav:["Behandlinger","Personale","Book tid"],
       tabs:["Hjemmeside","Booking","Personale","Betaling","Påmindelser"], title:"Dagens bookinger",
       k1:"Forudbetalt", k2:"Manuel booking",
       foot:"Booking, personalekalender, betaling og påmindelser. Alle moduler i salonens egen hjemmeside."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Klip & farve · 11:00",badge:"Forudbetalt"},
           {init:"TN",name:"Thomas Nilsen",meta:"Behandling · 13:30",badge:"Bekræftet"},
           {init:"SB",name:"Sara Berg",meta:"Ny kunde · 15:00",badge:"Betalt"}]},
    {key:"raadgivning", label:"Rådgivning", icon:"ti-headset",
     card:{url:"eksperterne.dk", brand:"DIN PLATFORM", nav:["Eksperter","Fagområder","Priser"],
       tabs:["Hjemmeside","Ekspertprofiler","Telefoni","Video","Betaling"], title:"Live opkaldskø",
       k1:"Godkendt på forhånd", k2:"Rykke for fakturaer",
       foot:"Telefoni, video og betaling per minut. Alle moduler i din egen hjemmeside."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Rådgivning · 12:04",badge:"Godkendt"},
           {init:"TN",name:"Thomas Nilsen",meta:"Juridisk · 08:47",badge:"I gang"},
           {init:"SB",name:"Sara Berg",meta:"Support · Video",badge:"Faktureret"}]},
  ],
},

/* ── NEDERLANDSK ────────────────────────────────────────────────────────── */
nl:{
  badge:"Operationele branche-oplossingen",
  h1a:"Een kant-en-klaar systeem", h1b:"voor jouw branche.", h1c:"De website zit erbij.",
  p:"Wij leveren niet alleen telefonie, video en betalingen. Wij leveren de hele bedrijfsvoering, als een systeemgebaseerde website waarin boeken, bezorging, betalen en factureren geïntegreerde modules zijn. Vanaf dag één ingericht voor jouw branche.",
  checks:[
    "Een systeemgebaseerde website zit altijd bij elk plan, nooit als extra",
    "Boekings- en bezorgtools in elke oplossing, afgestemd op de branche",
    "Telefonie, video, betalingen en facturatie als modules in hetzelfde systeem",
    "Jouw merk op je eigen domein, of gehost en beheerd door ons",
  ],
  cta1:"Demo boeken", cta2:"Prijzen bekijken",
  note:"Eenmalige implementatie, daarna een vaste maandlicentie. Wij nemen nooit een deel van je omzet.",
  partnerPre:"Erkend ", partnerPost:" MobilePay-partner",
  partnerSub:"Betalen met Vipps en MobilePay is in elke oplossing ingebouwd",
  payLabel:"Betalingen", vtLabel:"Kant-en-klare oplossingen voor",
  verticals:[
    {key:"zorg", label:"Zorg", icon:"ti-stethoscope",
     card:{url:"jouwkliniek.nl", brand:"JOUW KLINIEK", nav:["Behandelingen","Zorgverleners","Tarieven"],
       tabs:["Website","Agenda","Video","Betalingen","Herinneringen"], title:"Agenda vandaag",
       k1:"Vooraf geautoriseerd", k2:"Facturen najagen",
       foot:"Agenda, videoconsult, betalingen en herinneringen. Allemaal modules in de eigen website van de kliniek."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Consult · 09:15",badge:"Geautoriseerd"},
           {init:"TN",name:"Thomas Nilsen",meta:"Video · 10:00",badge:"Bezig"},
           {init:"SB",name:"Sara Berg",meta:"Nazorg · 10:45",badge:"Gefactureerd"}]},
    {key:"restaurant", label:"Restaurant", icon:"ti-tools-kitchen-2",
     card:{url:"jouwrestaurant.nl", brand:"JOUW RESTAURANT", nav:["Menu","Bestellen","Tafels"],
       tabs:["Website","Menu","Bestellen","Bezorging","Betalingen"], title:"Actieve orders",
       k1:"Betaald vóór bezorging", k2:"Handmatig invoeren",
       foot:"Menu, bestellen, bezorging en betalingen. Allemaal modules in de eigen website van het restaurant."},
     rows:[{init:"#4",name:"Order 1204",meta:"Bezorging · 12:04",badge:"Betaald"},
           {init:"#5",name:"Order 1205",meta:"Afhalen · 12:11",badge:"In bereiding"},
           {init:"T7",name:"Tafel 7",meta:"Reservering · 19:30",badge:"Bevestigd"}]},
    {key:"beauty", label:"Beauty & salon", icon:"ti-sparkles",
     card:{url:"jouwsalon.nl", brand:"JOUW SALON", nav:["Behandelingen","Team","Boek nu"],
       tabs:["Website","Boeken","Team","Betalingen","Herinneringen"], title:"Boekingen vandaag",
       k1:"Vooruitbetaald", k2:"Handmatig boeken",
       foot:"Boeken, teamagenda, betalingen en herinneringen. Allemaal modules in de eigen website van de salon."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Knippen & kleuren · 11:00",badge:"Vooruitbetaald"},
           {init:"TN",name:"Thomas Nilsen",meta:"Behandeling · 13:30",badge:"Bevestigd"},
           {init:"SB",name:"Sara Berg",meta:"Nieuwe klant · 15:00",badge:"Betaald"}]},
    {key:"advies", label:"Advies", icon:"ti-headset",
     card:{url:"jouwexperts.nl", brand:"JOUW PLATFORM", nav:["Experts","Vakgebieden","Tarieven"],
       tabs:["Website","Expertprofielen","Telefonie","Video","Betalingen"], title:"Live gesprekswachtrij",
       k1:"Vooraf geautoriseerd", k2:"Facturen najagen",
       foot:"Telefonie, video en betaling per minuut. Allemaal modules in je eigen website."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Advies · 12:04",badge:"Geautoriseerd"},
           {init:"TN",name:"Thomas Nilsen",meta:"Juridisch · 08:47",badge:"Bezig"},
           {init:"SB",name:"Sara Berg",meta:"Support · Video",badge:"Gefactureerd"}]},
  ],
},

/* ── TYSK ───────────────────────────────────────────────────────────────── */
de:{
  badge:"Operative Branchenlösungen",
  h1a:"Ein fertiges Betriebssystem", h1b:"für Ihre Branche.", h1c:"Die Website ist inklusive.",
  p:"Wir liefern nicht nur Telefonie, Video und Zahlungen. Wir liefern den gesamten Betrieb, als systembasierte Website, in der Buchung, Lieferung, Zahlung und Rechnungsstellung integrierte Module sind. Ab dem ersten Tag für Ihre Branche konfiguriert.",
  checks:[
    "Eine systembasierte Website ist immer in jedem Plan enthalten, nie ein Zusatz",
    "Buchungs- und Lieferwerkzeuge in jeder Lösung, auf die Branche zugeschnitten",
    "Telefonie, Video, Zahlung und Rechnungsstellung als Module im selben System",
    "Ihre Marke auf Ihrer eigenen Domain, oder von uns gehostet und betrieben",
  ],
  cta1:"Demo buchen", cta2:"Sprechen Sie uns an",
  note:"Einmalige Einrichtung, danach eine feste Monatslizenz. Wir nehmen niemals einen Anteil an Ihrem Umsatz.",
  partnerPre:"Autorisierter ", partnerPost:" MobilePay-Partner",
  partnerSub:"Zahlung mit Vipps und MobilePay ist in jeder Lösung integriert",
  payLabel:"Zahlungen", vtLabel:"Fertige Lösungen für",
  verticals:[
    {key:"gesundheit", label:"Gesundheit", icon:"ti-stethoscope",
     card:{url:"ihre-praxis.de", brand:"IHRE PRAXIS", nav:["Behandlungen","Behandler","Preise"],
       tabs:["Website","Terminbuch","Video","Zahlungen","Erinnerungen"], title:"Termine heute",
       k1:"Vorab autorisiert", k2:"Rechnungen nachfassen",
       foot:"Terminbuch, Videosprechstunde, Zahlungen und Erinnerungen. Alles Module in der eigenen Website der Praxis."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Beratung · 09:15",badge:"Autorisiert"},
           {init:"TN",name:"Thomas Nilsen",meta:"Video · 10:00",badge:"Läuft"},
           {init:"SB",name:"Sara Berg",meta:"Nachsorge · 10:45",badge:"Abgerechnet"}]},
    {key:"restaurant", label:"Restaurant", icon:"ti-tools-kitchen-2",
     card:{url:"ihr-restaurant.de", brand:"IHR RESTAURANT", nav:["Speisekarte","Bestellen","Tische"],
       tabs:["Website","Speisekarte","Bestellung","Lieferung","Zahlungen"], title:"Aktive Bestellungen",
       k1:"Bezahlt vor Lieferung", k2:"Manuelle Erfassung",
       foot:"Speisekarte, Bestellung, Lieferung und Zahlungen. Alles Module in der eigenen Website des Restaurants."},
     rows:[{init:"#4",name:"Bestellung 1204",meta:"Lieferung · 12:04",badge:"Bezahlt"},
           {init:"#5",name:"Bestellung 1205",meta:"Abholung · 12:11",badge:"In Zubereitung"},
           {init:"T7",name:"Tisch 7",meta:"Reservierung · 19:30",badge:"Bestätigt"}]},
    {key:"beauty", label:"Beauty & Kosmetik", icon:"ti-sparkles",
     card:{url:"ihr-salon.de", brand:"IHR SALON", nav:["Behandlungen","Team","Termin buchen"],
       tabs:["Website","Buchung","Team","Zahlungen","Erinnerungen"], title:"Buchungen heute",
       k1:"Vorausbezahlt", k2:"Manuelle Buchung",
       foot:"Buchung, Teamkalender, Zahlungen und Erinnerungen. Alles Module in der eigenen Website des Salons."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Schnitt & Farbe · 11:00",badge:"Vorausbezahlt"},
           {init:"TN",name:"Thomas Nilsen",meta:"Behandlung · 13:30",badge:"Bestätigt"},
           {init:"SB",name:"Sara Berg",meta:"Neukunde · 15:00",badge:"Bezahlt"}]},
    {key:"beratung", label:"Beratung", icon:"ti-headset",
     card:{url:"ihre-experten.de", brand:"IHRE PLATTFORM", nav:["Experten","Fachgebiete","Preise"],
       tabs:["Website","Expertenprofile","Telefonie","Video","Zahlungen"], title:"Live-Anrufwarteschlange",
       k1:"Vorab autorisiert", k2:"Rechnungen nachfassen",
       foot:"Telefonie, Video und Abrechnung pro Minute. Alles Module in Ihrer eigenen Website."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Beratung · 12:04",badge:"Autorisiert"},
           {init:"TN",name:"Thomas Nilsen",meta:"Recht · 08:47",badge:"Läuft"},
           {init:"SB",name:"Sara Berg",meta:"Support · Video",badge:"Abgerechnet"}]},
  ],
},

/* ── SPANSK ─────────────────────────────────────────────────────────────── */
es:{
  badge:"Soluciones operativas por sector",
  h1a:"Un sistema listo para usar", h1b:"para tu sector.", h1c:"La web está incluida.",
  p:"No solo hacemos telefonía, vídeo y pagos. Entregamos toda la operación, como una web basada en sistema donde reservas, entregas, pagos y facturación son módulos integrados. Configurada para tu sector desde el primer día.",
  checks:[
    "La web basada en sistema siempre está incluida en todos los planes, nunca es un extra",
    "Herramientas de reserva y entrega en todas las soluciones, adaptadas al sector",
    "Telefonía, vídeo, pagos y facturación como módulos del mismo sistema",
    "Tu marca en tu propio dominio, o alojado y gestionado por nosotros",
  ],
  cta1:"Solicitar una demo", cta2:"Habla con nosotros",
  note:"Pago único de implantación y después una licencia mensual fija. Nunca nos quedamos con un porcentaje de tus ingresos.",
  partnerPre:"Partner autorizado de ", partnerPost:" MobilePay",
  partnerSub:"El pago con Vipps y MobilePay está integrado en todas las soluciones",
  payLabel:"Pagos", vtLabel:"Soluciones listas para",
  verticals:[
    {key:"salud", label:"Salud", icon:"ti-stethoscope",
     card:{url:"tuclinica.es", brand:"TU CLÍNICA", nav:["Tratamientos","Profesionales","Precios"],
       tabs:["Web","Citas","Vídeo","Pagos","Recordatorios"], title:"Citas de hoy",
       k1:"Autorizado por adelantado", k2:"Reclamar facturas",
       foot:"Citas, videoconsulta, pagos y recordatorios. Todos módulos de la propia web de la clínica."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Consulta · 09:15",badge:"Autorizado"},
           {init:"TN",name:"Thomas Nilsen",meta:"Vídeo · 10:00",badge:"En curso"},
           {init:"SB",name:"Sara Berg",meta:"Seguimiento · 10:45",badge:"Facturado"}]},
    {key:"restaurante", label:"Restaurante", icon:"ti-tools-kitchen-2",
     card:{url:"turestaurante.es", brand:"TU RESTAURANTE", nav:["Carta","Pedir","Mesas"],
       tabs:["Web","Carta","Pedidos","Entrega","Pagos"], title:"Pedidos activos",
       k1:"Pagado antes de entregar", k2:"Registro manual",
       foot:"Carta, pedidos, entrega y pagos. Todos módulos de la propia web del restaurante."},
     rows:[{init:"#4",name:"Pedido 1204",meta:"Entrega · 12:04",badge:"Pagado"},
           {init:"#5",name:"Pedido 1205",meta:"Para llevar · 12:11",badge:"En preparación"},
           {init:"M7",name:"Mesa 7",meta:"Reserva · 19:30",badge:"Confirmada"}]},
    {key:"belleza", label:"Belleza", icon:"ti-sparkles",
     card:{url:"tusalon.es", brand:"TU SALÓN", nav:["Tratamientos","Equipo","Reservar"],
       tabs:["Web","Reservas","Equipo","Pagos","Recordatorios"], title:"Reservas de hoy",
       k1:"Prepagado", k2:"Reserva manual",
       foot:"Reservas, calendario del equipo, pagos y recordatorios. Todos módulos de la propia web del salón."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Corte y color · 11:00",badge:"Prepagado"},
           {init:"TN",name:"Thomas Nilsen",meta:"Tratamiento · 13:30",badge:"Confirmado"},
           {init:"SB",name:"Sara Berg",meta:"Cliente nuevo · 15:00",badge:"Pagado"}]},
    {key:"asesoria", label:"Asesoría", icon:"ti-headset",
     card:{url:"tusexpertos.es", brand:"TU PLATAFORMA", nav:["Expertos","Áreas","Precios"],
       tabs:["Web","Perfiles de expertos","Telefonía","Vídeo","Pagos"], title:"Cola de llamadas en vivo",
       k1:"Autorizado por adelantado", k2:"Reclamar facturas",
       foot:"Telefonía, vídeo y cobro por minuto. Todos módulos de tu propia web."},
     rows:[{init:"KA",name:"Kari Andersen",meta:"Asesoría · 12:04",badge:"Autorizado"},
           {init:"TN",name:"Thomas Nilsen",meta:"Legal · 08:47",badge:"En curso"},
           {init:"SB",name:"Sara Berg",meta:"Soporte · Vídeo",badge:"Facturado"}]},
  ],
},

};

export default HERO;
